<template>
  <page>
    <v-flex xs12>
      <form>
        <v-expansion-panel expand :value="[true]">
          <v-expansion-panel-content>
            <div slot="header">
              <v-icon>mdi-filter-variant</v-icon>Filters
            </div>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-model="filters.referrerCode" :label="filtersLabel.referrerCode" :error-messages="errors.collect('referrerCode')" data-vv-name="referrerCode" :data-vv-as="filtersLabel.referrerCode"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-model="filters.referrerDesc" :label="filtersLabel.referrerDesc" :error-messages="errors.collect('referrerDesc')" data-vv-name="referrerDesc" :data-vv-as="filtersLabel.referrerDesc"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-autocomplete :items="b2cKeys" v-model="filters.b2cKey" :label="filtersLabel.b2cKey" item-text="label" item-value="value" data-vv-name="b2cKey" :data-vv-as="filtersLabel.b2cKey" :error-messages="errors.collect('b2cKey')" clearable></v-autocomplete>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" flat="flat" @click.native="doClearFilters">Clear Filters</v-btn>
                <v-btn color="primary" flat="flat" type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
              </v-card-actions>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </form>
    </v-flex>
    <v-flex xs12 class="mt-3">
      <message :messages="messages"></message>
    </v-flex>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <div>
              <div class="headline">Referrers Listing</div>
            </div>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-data-table v-bind:headers="headers" v-bind:items="items" :total-items="totalItems" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="referrerCode" :loading="loading" :no-data-text="noDataText">
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <span slot="activator">{{ props.header.text }}</span>
                <span>{{ props.header.text }}</span>
              </v-tooltip>
            </template>
            <template slot="items" slot-scope="props">
              <td>{{ props.item.referrerCode }}</td>
              <td class="text-xs-right">{{ props.item.referrerDesc }}</td>
              <td class="text-xs-right">{{ props.item.b2cKey }}</td>
              <td class="text-xs-right">
                <table-action :rowData="props" :review="checkAccess(['referrerReview'])" :remove="checkAccess(['referrerReview'])" @review="doReview" @remove="doPromptRemove"></table-action>
              </td>
            </template>
          </v-data-table>
        </v-card>
        <div class="pt-2">
          <v-btn color="primary" @click="doNew">Add Referrer
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
    <confirm v-model="promptRemove" @ok="doRemove">Are you sure you want to delete Referrer - {{removeId}}?</confirm>
  </page>
</template>

<script>
import clone from 'clone'
import { ADMINB2C_REF_KEYS } from '@/store/types'
import { mapGetters } from 'vuex'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'

export default {
  data() {
    return {
      headers: [
        { text: 'Referrer Code', align: 'left', value: 'referrerCode' },
        { text: 'Description', align: 'right', value: 'referrerDesc' },
        { text: 'B2C Key', align: 'right', value: 'b2cKey' },
        TableConst.tableActionHeader
      ],
      totalItems: 0,
      filters: {
        referrerCode: null,
        referrerDesc: null
      },
      filtersLabel: {
        referrerCode: 'Referrer Code',
        referrerDesc: 'Description',
        b2cKey: 'B2C Key'
      },
      promptRemove: false,
      removeId: null
    }
  },
  computed: {
    ...mapGetters(['checkAccess']),
    b2cKeys() {
      return this.$store.state.adminB2c.referrers.keys
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination.descending': function(value) {
      this.fetchData(false)
    },
    'pagination.page': function(value) {
      this.fetchData(false)
    },
    'pagination.rowsPerPage': function(value) {
      this.fetchData(false)
    },
    'pagination.sortBy': function(value) {
      this.fetchData(false)
    }
  },
  methods: {
    async fetchData(options) {
      const apiUrl = this.$store.state.adminB2c.referrers.menu.listing
      if (apiUrl) {
        try {
          this.loading = true
          const { page, rowsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: rowsPerPage,
            options: options
          }
          // Massage the filters
          let massageFilters = clone(this.filters)

          const result = await this.$http.get(
            filterQuery(expandURI(apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.descending)
          )
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map(ref => {
                const convertRef = {
                  referrerCode: ref.referrerCode,
                  referrerDesc: ref.referrerDesc,
                  b2cKey: ref.b2cKey,
                  menu: extractMenu(ref._links)
                }
                this.items.push(convertRef)
              })
            } else {
              this.items = []
            }
            if (options) {
              this.$store.commit(ADMINB2C_REF_KEYS, result.data.b2cKeys)
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(false)
        }
      })
    },
    doClearFilters() {
      this.filters.referrerCode = null
      this.filters.referrerDesc = null
      this.fetchData(false)
    },
    doReview(data) {
      if (data && data.item && data.item.referrerCode) {
        this.$router.push({ name: 'referrerReview', params: { id: data.item.referrerCode } })
      }
    },
    doPromptRemove(data) {
      if (data && data.item && data.item.referrerCode) {
        this.removeId = data.item.referrerCode
        this.promptRemove = true
      }
    },
    async doRemove() {
      const toDelete = this.items.find(x => x.referrerCode === this.removeId)
      if (toDelete && toDelete.menu && toDelete.menu.deleteRef) {
        try {
          this.loading = true
          const result = await this.$http.delete(toDelete.menu.deleteRef)
          if (result.data) {
            this.message(result.data)

            // Refetch data
            this.fetchData(false)
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Failed to remove ' + this.removeId)
      }
    },
    doNew() {
      this.$router.push({ name: 'referrerReview', params: { id: 'new' } })
    }
  },
  mounted() {
    // Fetch Refs Data
    this.fetchData(true)
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style>
</style>
